export const CAR_INSPECTION_REQUEST = 'CAR_INSPECTION_REQUEST'
export const CAR_INSPECTION_LIST_SUCCESS = 'CAR_INSPECTION_LIST_SUCCESS'
export const CAR_INSPECTION_LIST_FAIL = 'CAR_INSPECTION_LIST_FAIL'
export const CAR_INSPECTION_RESET = 'CAR_INSPECTION_RESET'